import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import Share from '@components/icons/ShareIcon.svg';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { JobResponseDto } from 'app/API';
import toast from 'react-hot-toast';

export const AttorneysBlock = ({ attorneyAccesses }: { attorneyAccesses: JobResponseDto['attorneyAccesses'] }) => {
  const attorneys = attorneyAccesses ?? [];

  if (!attorneys?.length) {
    return null;
  }

  const onCopyButtonClick = (text: string) => {
    toast.success('The link has been copied to the clipboard', {
      duration: 2000,
    });
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="w-full">
      <TableWrapper className="w-full customTable">
        <Table>
          <Thead $white>
            <Tr>
              <Th>Email</Th>
              <Th>Passcode</Th>
              <Th>Created</Th>
            </Tr>
          </Thead>
          <Tbody>
            {attorneys.map((data, index) => (
              <Tr key={data.id ?? index}>
                <Td>
                  <p className="mt-3 mb-3">{data?.email}</p>
                </Td>
                <Td>
                  <p className="mt-3 mb-3 flex gap-2 items-center">
                    {data?.passcode && data.url ? (
                      <>
                        {data.passcode.toUpperCase()}
                        <Share
                          className="cursor-pointer hover:text-[var(--color-title)] text-[var(--color-text-muted)] fill-current"
                          onClick={() => onCopyButtonClick(data.url)}
                        />
                      </>
                    ) : (
                      'No passcode'
                    )}
                  </p>
                </Td>
                <Td>
                  <p className="mt-3 mb-3">{getAmericanTime(data.createdAt ?? 0)}</p>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>
    </div>
  );
};
